import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

import { ISendCaptchaDTO } from "../../components/AuthClientModal/AuthClientModal";
import { getPoizonClients } from "./getUserPoizonClients";

export const createCaptchaPoizonClientStore = (clientId: string) => {
  const getCaptchaPoizonClient = reatomAsync(
    (_ctx, { clientId, getCaptchaRequest }: ISendCaptchaDTO) => {
      return API.poizonSiteApi.userControllerGetCaptcha(
        clientId,
        getCaptchaRequest,
      );
    },
    `getCaptchaPoizonClient${clientId}`,
  ).pipe(withDataAtom(null), withIsLoadingAtom());

  const getCaptchaPoizonClientIsLoading = getCaptchaPoizonClient.isLoadingAtom;

  const loginPoizonClient = reatomAsync(
    (
      _ctx,
      clientId: string,
      code: string,
      userName: string,
      countryCode: number,
    ) => {
      return API.poizonSiteApi.userControllerLogin(clientId, {
        userName,
        code,
        countryCode,
        noToast: true,
        type: "code",
        password: "",
        authCode: "",
      });
    },
    "loginPoizonClient",
  ).pipe(withDataAtom(null), withIsLoadingAtom());

  loginPoizonClient.onFulfill.onCall((ctx) => getPoizonClients(ctx));

  const loginPoizonClientIsLoading = loginPoizonClient.isLoadingAtom;

  return {
    getCaptchaPoizonClient,
    getCaptchaPoizonClientIsLoading,
    loginPoizonClient,
    loginPoizonClientIsLoading,
  };
};
